module.exports = __webpack_public_path__ + "static/media/Build-a-burger.3bdace4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Build-a-burger.png
// module id = 88
// module chunks = 0